module.exports = __webpack_public_path__ + "img/blue_082.f1aab5d9.png";